import React, {ReactNode, useContext} from 'react';
import {CSSTransition} from "react-transition-group";
import {DropDownMenuContext} from "./DropDownMenu";

export type DropDownWindowProps = {
    windowName: string,
    transitionClassName: string
    children: ReactNode,
    timeout?: number,
    unMountOnExit?: boolean
}

function DropDownWindow(props: DropDownWindowProps) {
    const {windowName, transitionClassName, timeout, unMountOnExit = false} = props
    const {currentWindow} = useContext(DropDownMenuContext)
    const calcHeight = () => {}
    return (
         <CSSTransition classNames={transitionClassName} in={currentWindow === windowName}
                        timeout={timeout ? timeout: 500}
                        unmountOnExit={unMountOnExit}
                        onEnter={calcHeight}>
             <div className={"dropdown-window " + transitionClassName}>{props.children}</div>
        </CSSTransition>
    );
}

export default DropDownWindow;
